import { defineComponent, useCssVars, unref, ref, computed, openBlock, createElementBlock, createElementVNode, normalizeClass, createTextVNode, toDisplayString, createVNode, Transition, withCtx, Fragment, renderList, createCommentVNode, h, renderSlot, useSlots, useTemplateRef, watch, onMounted, createBlock, Teleport, mergeProps, getCurrentScope, onScopeDispose, useAttrs, onBeforeUnmount } from 'vue';
import { _ as _export_sfc, a as useI18n, h as useElementBounding, i as onKeyStroke, u as useTheme, j as useEventListener, k as useSwipe, e as _export_sfc$1 } from '../review.es.js';

const icon$1 = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M4.47 6.97a.75.75 0 011.06 0L10 11.44l4.47-4.47a.75.75 0 111.06 1.06l-5 5a.75.75 0 01-1.06 0l-5-5a.75.75 0 010-1.06z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const _hoisted_1$7 = ["tabindex", "aria-expanded", "aria-label"];
const _hoisted_2$5 = {
  key: 0,
  id: "custom-select-items",
  class: "items",
  role: "listbox"
};
const _hoisted_3$4 = ["aria-selected", "onClick"];
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "CustomSelect",
  props: {
    options: {},
    modelValue: {},
    tabindex: { default: 0 }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    useCssVars((_ctx) => ({
      "97018cb2": `${unref(selectedElementWidth)}px`
    }));
    const props = __props;
    const emit = __emit;
    const { t } = useI18n();
    const selectedElement = ref();
    const {
      width: selectedElementWidth
    } = useElementBounding(selectedElement);
    const open = ref(false);
    const selected = computed({
      get() {
        return props.modelValue;
      },
      set(value) {
        emit("update:modelValue", value);
      }
    });
    const selectedLabel = computed(() => props.options.find((option) => option.value === selected.value)?.label);
    const selectedIdx = computed(() => props.options.findIndex((option) => option.value === selected.value));
    function selectNext() {
      if (selectedIdx.value < props.options.length - 1) {
        selected.value = props.options[selectedIdx.value + 1].value;
      }
    }
    function selectPrev() {
      if (selectedIdx.value > 0) {
        selected.value = props.options[selectedIdx.value - 1].value;
      }
    }
    onKeyStroke("ArrowDown", () => {
      if (!open.value) {
        open.value = true;
      } else {
        selectNext();
      }
    }, { target: selectedElement });
    onKeyStroke("ArrowUp", () => {
      selectPrev();
    }, { target: selectedElement });
    onKeyStroke("Escape", (e) => {
      if (!open.value) {
        return;
      }
      e.stopPropagation();
      open.value = false;
    }, { target: selectedElement });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "custom-select",
        onBlur: _cache[1] || (_cache[1] = ($event) => open.value = false)
      }, [
        createElementVNode("button", {
          ref_key: "selectedElement",
          ref: selectedElement,
          type: "button",
          role: "combobox",
          tabindex: _ctx.tabindex,
          "aria-expanded": open.value,
          "aria-haspopup": "",
          "aria-controls": "custom-select-items",
          "aria-label": props.options[0].label,
          class: normalizeClass(["selected", { open: open.value }]),
          onClick: _cache[0] || (_cache[0] = ($event) => open.value = !open.value)
        }, [
          createTextVNode(toDisplayString(selectedLabel.value) + " ", 1),
          createElementVNode("i", null, [
            createVNode(unref(icon$1), {
              "aria-label": unref(t)("Arrow icon")
            }, null, 8, ["aria-label"])
          ])
        ], 10, _hoisted_1$7),
        createVNode(Transition, { name: "fade" }, {
          default: withCtx(() => [
            open.value ? (openBlock(), createElementBlock("div", _hoisted_2$5, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (item) => {
                return openBlock(), createElementBlock("div", {
                  key: item.value,
                  role: "option",
                  tabindex: "-1",
                  "aria-selected": selected.value === item.value,
                  class: normalizeClass(["item", { active: selected.value === item.value }]),
                  onClick: ($event) => {
                    selected.value = item.value;
                    open.value = false;
                  }
                }, toDisplayString(item.label), 11, _hoisted_3$4);
              }), 128))
            ])) : createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 32);
    };
  }
});

const CustomSelect = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["__scopeId", "data-v-da539965"]]);

const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "List",
  props: {
    items: {},
    itemId: { type: Function }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", null, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(props.items, (item, idx) => {
          return openBlock(), createElementBlock("li", {
            key: props.itemId ? props.itemId(item) : idx
          }, [
            renderSlot(_ctx.$slots, "default", { item }, void 0, true)
          ]);
        }), 128))
      ]);
    };
  }
});

const List = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["__scopeId", "data-v-b2eb0de9"]]);

const _hoisted_1$6 = { class: "recordGrid__item__name" };
const _hoisted_2$4 = { class: "recordGrid__item__value" };
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "RecordGrid",
  props: {
    items: {},
    direction: { default: "column" },
    responsive: { type: Boolean, default: true },
    fontSize: { default: "small" }
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "38704221": _ctx.direction,
      "36b2eaf8": gap.value,
      "d846e964": unref(itemDirection),
      "40576db2": unref(valueAlign)
    }));
    const props = __props;
    const itemDirection = props.direction === "row" ? "column" : "row";
    const valueAlign = props.direction === "row" ? "center" : "end";
    const gap = computed(() => {
      if (props.direction === "row") {
        return "16px";
      }
      if (props.fontSize === "large") {
        return "8px";
      }
      return "2.5px";
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", {
        class: normalizeClass([
          "recordGrid",
          `recordGrid--${props.direction}`,
          `recordGrid--${props.items.length}items`,
          `recordGrid--${props.fontSize}-fontsize`,
          { "recordGrid--responsive": props.responsive }
        ])
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item, idx) => {
          return openBlock(), createElementBlock("li", {
            class: "recordGrid__item",
            key: idx
          }, [
            createElementVNode("span", _hoisted_1$6, [
              renderSlot(_ctx.$slots, "name", { item }, () => [
                createTextVNode(toDisplayString(item.name), 1)
              ], true)
            ]),
            createElementVNode("span", _hoisted_2$4, [
              renderSlot(_ctx.$slots, "value", { item }, void 0, true)
            ])
          ]);
        }), 128))
      ], 2);
    };
  }
});

const RecordGrid = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["__scopeId", "data-v-ca152712"]]);

function getScrollableParent(node) {
  if (node === null) return null;
  if (node.scrollHeight > node.clientHeight) return node;
  return getScrollableParent(node.parentNode);
}

function O(t) {
  return getCurrentScope() ? (onScopeDispose(t), !0) : !1;
}
const P = typeof window < "u", $ = (t) => typeof t == "string", u = () => {
};
function y(t) {
  var r;
  const n = unref(t);
  return (r = n == null ? void 0 : n.$el) != null ? r : n;
}
const b$1 = P ? window : void 0;
function L(...t) {
  let r, n, e, o;
  if ($(t[0]) ? ([n, e, o] = t, r = b$1) : [r, n, e, o] = t, !r)
    return u;
  let a = u;
  const s = watch(() => unref(r), (i) => {
    a(), i && (i.addEventListener(n, e, o), a = () => {
      i.removeEventListener(n, e, o), a = u;
    });
  }, { immediate: !0, flush: "post" }), p = () => {
    s(), a();
  };
  return O(p), p;
}
var d = Object.getOwnPropertySymbols, g = Object.prototype.hasOwnProperty, j = Object.prototype.propertyIsEnumerable, I = (t, r) => {
  var n = {};
  for (var e in t)
    g.call(t, e) && r.indexOf(e) < 0 && (n[e] = t[e]);
  if (t != null && d)
    for (var e of d(t))
      r.indexOf(e) < 0 && j.call(t, e) && (n[e] = t[e]);
  return n;
};
function T(t, r, n = {}) {
  const e = n, { window: o = b$1 } = e, a = I(e, ["window"]);
  let s;
  const p = o && "ResizeObserver" in o, i = () => {
    s && (s.disconnect(), s = void 0);
  }, v = watch(() => y(t), (l) => {
    i(), p && o && l && (s = new o.ResizeObserver(r), s.observe(l, a));
  }, { immediate: !0, flush: "post" }), f = () => {
    i(), v();
  };
  return O(f), {
    isSupported: p,
    stop: f
  };
}
var m;
(function(t) {
  t.UP = "UP", t.RIGHT = "RIGHT", t.DOWN = "DOWN", t.LEFT = "LEFT", t.NONE = "NONE";
})(m || (m = {}));

function b(c) {
  const n = ref(0), o = ref(0), l = ref(0), s = ref(0), r = ref(0), a = ref(0), i = ref(0), v = ref(0);
  function u() {
    const f = y(c);
    if (!f) {
      n.value = 0, o.value = 0, l.value = 0, s.value = 0, r.value = 0, a.value = 0, i.value = 0, v.value = 0;
      return;
    }
    const e = f.getBoundingClientRect();
    n.value = e.height, o.value = e.bottom, l.value = e.left, s.value = e.right, r.value = e.top, a.value = e.width, i.value = e.x, v.value = e.y;
  }
  return L("scroll", u, !0), L(window, "resize", u, !0), T(
    c,
    u
  ), {
    height: n,
    bottom: o,
    left: l,
    right: s,
    top: r,
    width: a,
    x: i,
    y: v,
    update: u
  };
}

const _hoisted_1$5 = { class: "inner" };
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "Tooltip",
  props: {
    mode: { default: "hover" },
    modelValue: { type: Boolean, default: true },
    placement: { default: "top" },
    minWidth: { default: 0 },
    maxWidth: { default: 0 },
    nowrap: { type: Boolean, default: true },
    callbackHide: { type: Function, default: void 0 },
    disabled: { type: Boolean, default: false },
    zIndexTooltip: { default: "9999" },
    colorScheme: { default: "info" },
    container: { default: "body" }
  },
  emits: [
    "visible"
  ],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const slots = useSlots();
    const isShowing = ref(false);
    const tooltipWrapper = useTemplateRef("tooltipWrapper");
    const tooltipElement = useTemplateRef("tooltipElement");
    const theme = useTheme();
    const {
      top: wrapperTop,
      left: wrapperLeft,
      bottom: wrapperBottom,
      right: wrapperRight,
      width: wrapperWidth,
      height: wrapperHeight,
      update: updateWrapperPosition
    } = b(tooltipWrapper);
    const {
      width: tooltipWidth,
      height: tooltipHeight
    } = b(tooltipElement);
    const tooltipLeft = computed(() => {
      switch (props.placement) {
        case "top":
        case "bottom":
          return wrapperLeft.value + (wrapperWidth.value - tooltipWidth.value) / 2;
        case "top-start":
        case "bottom-start":
          return wrapperLeft.value;
        case "top-end":
        case "bottom-end":
          return wrapperRight.value - tooltipWidth.value;
        case "left":
          return wrapperLeft.value - tooltipWidth.value;
        case "right":
          return wrapperRight.value;
        default:
          return 0;
      }
    });
    const tooltipTop = computed(() => {
      switch (props.placement) {
        case "top":
          return wrapperTop.value - tooltipHeight.value;
        case "top-start":
        case "top-end":
          return wrapperTop.value - tooltipHeight.value;
        case "bottom":
          return wrapperBottom.value;
        case "bottom-start":
        case "bottom-end":
          return wrapperBottom.value;
        case "left":
        case "right":
          return wrapperTop.value + (wrapperHeight.value - tooltipHeight.value) / 2;
        default:
          return 0;
      }
    });
    const tooltipStyle = computed(() => ({
      "border-radius": theme.borderRadius,
      left: `${tooltipLeft.value}px`,
      top: `${tooltipTop.value}px`,
      "z-index": props.zIndexTooltip,
      "white-space": props.nowrap ? "nowrap" : "normal",
      "min-width": props.minWidth > 0 ? `${props.minWidth}px` : "auto",
      "max-width": props.maxWidth > 0 ? `${props.maxWidth}px` : "none"
    }));
    function showTooltip() {
      if (!isShowing.value) {
        isShowing.value = true;
        updateWrapperPosition();
        emit("visible", true);
      }
    }
    function hideTooltip() {
      if (isShowing.value) {
        isShowing.value = false;
        emit("visible", false);
      }
    }
    function autoHideWithMode(event) {
      const hoverAndMouseleave = props.mode === "hover" && event.type === "mouseleave";
      const clickOutside = props.mode === "click" && event.type === "click" && (tooltipWrapper.value && !tooltipWrapper.value.contains(event.target));
      if (hoverAndMouseleave || clickOutside) {
        hideTooltip();
      }
    }
    function autoShowWithMode(event) {
      if (props.mode === "hover") {
        if (event.type === "mouseenter") {
          showTooltip();
        }
        return;
      }
      if (props.mode === "click" && event.type === "click") {
        if (isShowing.value) {
          hideTooltip();
        } else {
          showTooltip();
        }
      }
    }
    watch(() => props.modelValue, (current) => {
      if (current && props.mode === "manual") {
        showTooltip();
      } else if (!current && (props.mode === "manual" || props.mode === "click")) {
        hideTooltip();
      }
    });
    onMounted(() => {
      if (props.mode === "manual" && props.modelValue) {
        showTooltip();
      }
      useEventListener(document, "click", autoHideWithMode);
      if (tooltipWrapper.value) {
        const scrollableParent = getScrollableParent(tooltipWrapper.value);
        if (scrollableParent) useEventListener(scrollableParent, "scroll", hideTooltip);
      }
    });
    const TriggerElement = () => {
      const attrs = !props.disabled ? {
        type: "button",
        onMouseenter: autoShowWithMode,
        onFocusin: autoShowWithMode,
        onMouseleave: autoHideWithMode,
        onFocusout: autoHideWithMode,
        onClick: autoShowWithMode,
        onKeypress: autoShowWithMode
      } : {};
      return h(
        props.disabled ? "div" : "button",
        {
          ...attrs,
          class: [
            "trigger",
            { "trigger--disabled": props.disabled }
          ],
          "data-testid": "tooltipTrigger"
        },
        h(
          "div",
          { "data-testid": "triggerWrapper" },
          slots.trigger()
        )
      );
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "tooltipWrapper",
        ref: tooltipWrapper,
        "data-testid": "tooltipWrapper"
      }, [
        createVNode(TriggerElement),
        (openBlock(), createBlock(Teleport, {
          to: props.container
        }, [
          isShowing.value ? (openBlock(), createElementBlock("div", mergeProps({
            key: 0,
            ref_key: "tooltipElement",
            ref: tooltipElement,
            "data-testid": "tooltipElement",
            class: `tooltip ${props.placement} ${props.colorScheme}`,
            style: tooltipStyle.value
          }, _ctx.$attrs), [
            createElementVNode("div", _hoisted_1$5, [
              renderSlot(_ctx.$slots, "tooltip", {}, void 0, true)
            ]),
            createElementVNode("div", {
              class: normalizeClass(`tooltip-arrow ${props.placement}`)
            }, null, 2)
          ], 16)) : createCommentVNode("", true)
        ], 8, ["to"]))
      ], 512);
    };
  }
});

const Tooltip = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["__scopeId", "data-v-23b20b51"]]);

var AgentActionKind;
(function (AgentActionKind) {
    /**
     * Action to be called when applying a discount code (of any kind, not just of type "promocode").
     *
     * It corresponds to the Nostromo type `ButtonActionKind.ApplyPromoCode`.
     */
    AgentActionKind["ApplyDiscount"] = "apply-discount";
    /**
     * Action to be called when a UI/view is definetively closed from the [x] button
     * (or by a backdrop click) without having engaged with the contents of the message.
     */
    AgentActionKind["Dismiss"] = "dismiss";
    /**
     * Action to be called when a user positively engages with the UI/view, for instance
     * by executing a CTA. This is an exclusively disjunctive action with "dismiss", either
     * one or the other can happen, never both.
     */
    AgentActionKind["Engage"] = "engage";
    /**
     * Action to be called when a UI/view is closed.
     */
    AgentActionKind["Hide"] = "hide";
    /**
     * This action is usually called in replacemend of a CTA action
     * (like ApplyDiscount, OpenBookingEngine, OpenUri) when those actions
     * do not have a handler defined.
     *
     * Additionally is used by the Nostromo type `ButtonActionKind.CloseTool` on Inliners.
     */
    AgentActionKind["NoAction"] = "no-action";
    /**
     * Action that should never be called, is a Noop.
     */
    AgentActionKind["Fallback"] = "none";
    /**
     * Action to be called when a click happends on _any_ generic link of the contents.
     * By 'generic link' we mean a link not formally defined in the data struct, but just part of a
     * rich text/html of the message. This action should not be called when for clicks on buttons/CTAs.
     */
    AgentActionKind["GenericLinkClick"] = "generic-link-click";
    /**
     * Action to be called when loading a custom JS script.
     */
    AgentActionKind["LoadScript"] = "load-script";
    /**
     * Action to be called when opening the Booking Engine page, either with the default search data,
     * or with the last search data.
     *
     * It corresponds to the Nostromo type `ButtonActionKind.OpenBookingEngine`,
     * and `ButtonActionKind.LastSearch`.
     */
    AgentActionKind["OpenBookingEngine"] = "open-be";
    /**
     * Action to be called when opening a URI (either http(s), mail or tel).
     *
     * It corresponds to the Nostromo types `ButtonActionKind.OpenUrl`,
     * `ButtonActionKind.OpenMailClient` and `ButtonActionKind.CallPhoneNumber`.
     */
    AgentActionKind["OpenUri"] = "open-uri";
    /**
     * Action to be called to classify the visitor in an Audience group.
     */
    AgentActionKind["PredictiveAudience"] = "predictive-audience";
    /**
     * Action to be called when sending a (custom) form to the Site.
     *
     * It corresponds to the Nostromo type `ToolModuleKind.Form`.
     */
    AgentActionKind["SendForm"] = "send-form";
    /**
     * Action to be called when the visitor is sending a save-your-search email to himself/herself.
     * It corresponds to the Nostromo types `ToolModuleKind.SavedSearch` and
     * `ButtonActionKind.SavedSearch`.
     */
    AgentActionKind["SendSaveSearch"] = "send-save-search";
    /**
     * Action to be called when sending a contact email to the Site.
     */
    AgentActionKind["SendSiteContact"] = "send-site-contact";
    /**
     * Action to be called when subscribing to a mailing list, newsletter or similar.
     *
     * It corresponds to the Nostromo type `ToolModuleKind.EmailCapture`.
     */
    AgentActionKind["SendSubscribe"] = "send-subscribe";
    /**
     * Action to be called when a UI is displayed.
     */
    AgentActionKind["Show"] = "show";
    /**
     * Action to be called when the visitor is signing-in or signing-up with with THN.
     *
     * It corresponds to the Nostromo type `ToolModuleKind.Login`.
     */
    AgentActionKind["Login"] = "login";
    /**
     * Action to be called when a message/tool that needs to "move" the full body content is displayed.
     */
    AgentActionKind["TranslateDocumentBody"] = "translate-document-body";
})(AgentActionKind || (AgentActionKind = {}));
var AgentActionLoginStep;
(function (AgentActionLoginStep) {
    AgentActionLoginStep["Resend"] = "resend";
    AgentActionLoginStep["Signup"] = "signup";
    AgentActionLoginStep["Signin"] = "signin";
    AgentActionLoginStep["Validation"] = "validation";
})(AgentActionLoginStep || (AgentActionLoginStep = {}));

var Locale;
(function (Locale) {
    Locale["Arabic"] = "ar";
    Locale["Basque"] = "eu";
    Locale["Bulgarian"] = "bg";
    Locale["Catalan"] = "ca";
    Locale["Chinese"] = "zh";
    Locale["ChineseTraditional"] = "zh-TW";
    Locale["Croatian"] = "hr";
    Locale["Czech"] = "cs";
    Locale["Danish"] = "da";
    Locale["Deutsch"] = "de";
    Locale["Dutch"] = "nl";
    Locale["English"] = "en";
    Locale["Estonian"] = "et";
    Locale["Finnish"] = "fi";
    Locale["French"] = "fr";
    Locale["Greek"] = "el";
    Locale["Hebrew"] = "he";
    Locale["Hungarian"] = "hu";
    Locale["Icelandic"] = "is";
    Locale["Indonesian"] = "id";
    Locale["Italian"] = "it";
    Locale["Japanese"] = "ja";
    Locale["Korean"] = "ko";
    Locale["Lithuanian"] = "lt";
    Locale["Norwegian"] = "no";
    Locale["Polish"] = "pl";
    Locale["Portuguese"] = "pt";
    Locale["Romanian"] = "ro";
    Locale["Russian"] = "ru";
    Locale["Slovenian"] = "sl";
    Locale["Spanish"] = "es";
    Locale["Swedish"] = "sv";
    Locale["Thai"] = "th";
    Locale["Turkish"] = "tr";
    Locale["Ukrainian"] = "uk";
    Locale["Vietnamese"] = "vi";
})(Locale || (Locale = {}));

var CustomRulesSection;
(function (CustomRulesSection) {
    CustomRulesSection["Timing"] = "timing";
    CustomRulesSection["Oraculo"] = "oraculo";
    CustomRulesSection["VisitorProfile"] = "visitorProfile";
    CustomRulesSection["VisitorBehaviour"] = "visitorBehaviour";
    CustomRulesSection["Search"] = "search";
    CustomRulesSection["TravelParty"] = "travelParty";
    CustomRulesSection["DataVariables"] = "dataVariables";
    CustomRulesSection["Demand"] = "demand";
    CustomRulesSection["Integrations"] = "integrations";
})(CustomRulesSection || (CustomRulesSection = {}));
var ConditionKind;
(function (ConditionKind) {
    ConditionKind["Exclude"] = "exclude";
    ConditionKind["Include"] = "include";
})(ConditionKind || (ConditionKind = {}));
var Operator;
(function (Operator) {
    Operator["Any"] = "any";
    Operator["Is"] = "is";
    Operator["Are"] = "are";
    Operator["IsBetween"] = "isBetween";
    Operator["AreBetween"] = "areBetween";
    Operator["IsLower"] = "isLower";
    Operator["AreLower"] = "areLower";
    Operator["IsHigher"] = "isHigher";
    Operator["IsGreater"] = "isGreater";
    Operator["AreGreater"] = "areGreater";
    Operator["IsBefore"] = "isBefore";
    Operator["AreBefore"] = "areBefore";
    Operator["IsAfter"] = "isAfter";
    Operator["AreAfter"] = "areAfter";
    Operator["Contain"] = "contain";
})(Operator || (Operator = {}));
var DataVariableRuleOperator;
(function (DataVariableRuleOperator) {
    DataVariableRuleOperator["Is"] = "is";
    DataVariableRuleOperator["IsNot"] = "isNot";
    DataVariableRuleOperator["AnyValue"] = "anyValue";
    DataVariableRuleOperator["NotAnyValue"] = "notAnyValue";
    DataVariableRuleOperator["Lower"] = "lower";
    DataVariableRuleOperator["Greater"] = "greater";
    DataVariableRuleOperator["Contains"] = "contains";
    DataVariableRuleOperator["NotContains"] = "notContains";
})(DataVariableRuleOperator || (DataVariableRuleOperator = {}));
/**
 * The visitor registration status in the website own credentials system.
 */
var VisitorStatus;
(function (VisitorStatus) {
    /**
     * @alias VisitorStatus.RegisteredAndLogged
     * @deprecated
     */
    VisitorStatus["Registered"] = "registered";
    /**
     * @alias VisitorStatus.NotLogged
     * @deprecated
     */
    VisitorStatus["NonRegistered"] = "non_registered";
    /**
     * The visitor is currently logged-in. Implicitly the visitor needs to be registered,
     * however there should be no strict check about registration status on implementations.
     */
    VisitorStatus["RegisteredAndLogged"] = "registered";
    /**
     * The visitor is not registered. This implicitly means the visitor is also
     * NOT currently logged-in, as being logged-in would imply registration.
     */
    VisitorStatus["NotRegisteredAndNotLogged"] = "non_registered_nor_logged";
    /**
     * The visitor is registered. If the visitor were to be currently logged-in that (too)
     * would imply It is registered.
     */
    VisitorStatus["RegisteredOrLogged"] = "registered_all";
    /**
     * The visitor is registered AND is not currently logged-in.
     */
    VisitorStatus["RegisteredAndNotLogged"] = "registered_non_logged";
    /**
     * The visitor is currently not logged-in, disregarding registration status.
     */
    VisitorStatus["NotLogged"] = "non_registered";
})(VisitorStatus || (VisitorStatus = {}));
// This is for the thn/instant login system
var VisitorLogin;
(function (VisitorLogin) {
    VisitorLogin["Logged"] = "logged";
    VisitorLogin["NonLogged"] = "nonLogged";
})(VisitorLogin || (VisitorLogin = {}));
var VisitorBehaviourInteractionType;
(function (VisitorBehaviourInteractionType) {
    VisitorBehaviourInteractionType["Any"] = "any";
    VisitorBehaviourInteractionType["First"] = "first";
    VisitorBehaviourInteractionType["All"] = "all";
    VisitorBehaviourInteractionType["Search"] = "search";
    VisitorBehaviourInteractionType["Booked"] = "booked";
    VisitorBehaviourInteractionType["Custom"] = "custom";
})(VisitorBehaviourInteractionType || (VisitorBehaviourInteractionType = {}));

var MainStyle;
(function (MainStyle) {
    MainStyle["Colors"] = "colors";
    MainStyle["Fonts"] = "fonts";
    MainStyle["Button"] = "button";
    MainStyle["SecondaryButton"] = "secondaryButton";
    MainStyle["Background"] = "background";
    MainStyle["Overlay"] = "overlay";
})(MainStyle || (MainStyle = {}));
// FONTS
var TextTransform;
(function (TextTransform) {
    TextTransform["None"] = "none";
    TextTransform["Uppercase"] = "uppercase";
    TextTransform["Lowercase"] = "lowercase";
    TextTransform["Titlecase"] = "titlecase";
})(TextTransform || (TextTransform = {}));
var FontType;
(function (FontType) {
    FontType["Google"] = "google";
    FontType["File"] = "file";
    FontType["Regular"] = "regular";
})(FontType || (FontType = {}));
// BUTTONS
var RadiusKind;
(function (RadiusKind) {
    RadiusKind["Custom"] = "custom";
    RadiusKind["Square"] = "square";
    RadiusKind["Medium"] = "medium";
    RadiusKind["Rounded"] = "rounded";
})(RadiusKind || (RadiusKind = {}));
var MeasureUnit;
(function (MeasureUnit) {
    MeasureUnit["Percentage"] = "%";
    MeasureUnit["Pixels"] = "px";
    MeasureUnit["Rem"] = "rem";
    MeasureUnit["Em"] = "em";
})(MeasureUnit || (MeasureUnit = {}));
var ButtonStyleKind;
(function (ButtonStyleKind) {
    ButtonStyleKind["Solid"] = "solid";
    ButtonStyleKind["Outline"] = "outline";
})(ButtonStyleKind || (ButtonStyleKind = {}));

var TermsLinkKind;
(function (TermsLinkKind) {
    TermsLinkKind["Url"] = "url";
    TermsLinkKind["DefaultText"] = "default_text";
    TermsLinkKind["CustomText"] = "custom_text";
    TermsLinkKind["NotLinked"] = "not_linked";
    TermsLinkKind["CustomUrl"] = "custom_url";
})(TermsLinkKind || (TermsLinkKind = {}));

var ActivityKind;
(function (ActivityKind) {
    ActivityKind["NowViewing"] = "nowViewing";
    ActivityKind["TodayViewed"] = "todayViewed";
    ActivityKind["BookedToday"] = "bookedToday";
    ActivityKind["LastReservation"] = "lastReservation";
    ActivityKind["DiscountToday"] = "discountToday";
    ActivityKind["TodaySpecialOffer"] = "todaySpecialOffer";
})(ActivityKind || (ActivityKind = {}));

var ButtonActionKind;
(function (ButtonActionKind) {
    ButtonActionKind["ApplyPromoCode"] = "apply_promo_code";
    ButtonActionKind["OpenUrl"] = "open_url";
    ButtonActionKind["OpenMailClient"] = "open_mail_client";
    ButtonActionKind["CallPhoneNumber"] = "call_phone_number";
    ButtonActionKind["CloseTool"] = "close_tool";
    ButtonActionKind["EmailCapture"] = "email_capture";
    ButtonActionKind["SavedSearch"] = "saved_search";
    ButtonActionKind["GoMainStep"] = "go_main_step";
    ButtonActionKind["SendForm"] = "form";
    ButtonActionKind["OpenBookingEngine"] = "send_to_be";
    ButtonActionKind["Submit"] = "submit";
    ButtonActionKind["LastSearch"] = "send_to_last_search";
})(ButtonActionKind || (ButtonActionKind = {}));
var DiscountCodeKind;
(function (DiscountCodeKind) {
    DiscountCodeKind["Default"] = "default";
    DiscountCodeKind["Coupon"] = "coupon";
    DiscountCodeKind["Rate"] = "rate";
    DiscountCodeKind["Corporative"] = "corpo";
    DiscountCodeKind["Group"] = "group";
})(DiscountCodeKind || (DiscountCodeKind = {}));
var ButtonKind;
(function (ButtonKind) {
    ButtonKind["Primary"] = "primary";
    ButtonKind["Secondary"] = "secondary";
})(ButtonKind || (ButtonKind = {}));

var ToolKind;
(function (ToolKind) {
    ToolKind["Note"] = "note";
    ToolKind["Layer"] = "layer";
    ToolKind["Exit"] = "exit";
    ToolKind["Inliner"] = "inliner";
})(ToolKind || (ToolKind = {}));
// @deprecated ?
var DefaultStep;
(function (DefaultStep) {
    DefaultStep["Success"] = "success";
    DefaultStep["Failure"] = "failure";
    DefaultStep["Main"] = "main";
})(DefaultStep || (DefaultStep = {}));
var LoginStep;
(function (LoginStep) {
    LoginStep["LoginSignin"] = "login-signin";
    LoginStep["LoginRegister"] = "login-register";
    LoginStep["LoginSuccess"] = "login-success";
})(LoginStep || (LoginStep = {}));

var ToolModuleKind;
(function (ToolModuleKind) {
    ToolModuleKind["Activity"] = "activity";
    ToolModuleKind["Button"] = "button";
    ToolModuleKind["Countdown"] = "countdown";
    ToolModuleKind["EmailCapture"] = "emailCapture";
    ToolModuleKind["Form"] = "form";
    ToolModuleKind["Heading"] = "heading";
    ToolModuleKind["ImageWithBehaviour"] = "imageWithBehaviour";
    ToolModuleKind["Icon"] = "icon";
    ToolModuleKind["Paragraph"] = "paragraph";
    ToolModuleKind["Perks"] = "perks";
    ToolModuleKind["SavedSearch"] = "savedSearch";
    ToolModuleKind["Spacer"] = "spacer";
    ToolModuleKind["Login"] = "login";
})(ToolModuleKind || (ToolModuleKind = {}));

var PerkTooltipKind;
(function (PerkTooltipKind) {
    PerkTooltipKind["None"] = "none";
    PerkTooltipKind["WebExclusive"] = "web_exclusive";
    PerkTooltipKind["SubjectToAvailibity"] = "subject_to_availability";
    PerkTooltipKind["OnlyForSpecificRates"] = "only_for_specific_rates";
    PerkTooltipKind["OnlyForRegisterdUsers"] = "only_for_registered_users";
})(PerkTooltipKind || (PerkTooltipKind = {}));
var PerkLayoutKind;
(function (PerkLayoutKind) {
    PerkLayoutKind["Bullets"] = "bullets";
    PerkLayoutKind["Highlights"] = "highlights";
})(PerkLayoutKind || (PerkLayoutKind = {}));

var CountdownStyle;
(function (CountdownStyle) {
    CountdownStyle["None"] = "none";
    CountdownStyle["Solid"] = "solid";
    CountdownStyle["Outline"] = "outline";
})(CountdownStyle || (CountdownStyle = {}));
var CountdownSize;
(function (CountdownSize) {
    CountdownSize["Normal"] = "normal";
    CountdownSize["Compact"] = "compact";
})(CountdownSize || (CountdownSize = {}));
var CountdownKind;
(function (CountdownKind) {
    CountdownKind["Date"] = "date";
    CountdownKind["Time"] = "time";
})(CountdownKind || (CountdownKind = {}));
var CountdownTimezone;
(function (CountdownTimezone) {
    CountdownTimezone["Visitor"] = "visitor";
    CountdownTimezone["Hotel"] = "hotel";
})(CountdownTimezone || (CountdownTimezone = {}));

var FormFieldsPosition;
(function (FormFieldsPosition) {
    FormFieldsPosition["Out"] = "out";
    FormFieldsPosition["Inside"] = "inside";
})(FormFieldsPosition || (FormFieldsPosition = {}));
var FormSelectionKind;
(function (FormSelectionKind) {
    FormSelectionKind["Single"] = "single";
    FormSelectionKind["Multiple"] = "multiple";
})(FormSelectionKind || (FormSelectionKind = {}));
var FormFieldKind;
(function (FormFieldKind) {
    FormFieldKind["ShortText"] = "shortText";
    FormFieldKind["Email"] = "email";
    FormFieldKind["Phone"] = "phone";
    FormFieldKind["Date"] = "date";
    FormFieldKind["LongText"] = "longText";
    FormFieldKind["DropDown"] = "dropdown";
    FormFieldKind["Selection"] = "selection";
})(FormFieldKind || (FormFieldKind = {}));

var ToolPosition;
(function (ToolPosition) {
    ToolPosition["Top"] = "T";
    ToolPosition["Bottom"] = "B";
    ToolPosition["Left"] = "L";
    ToolPosition["Right"] = "R";
    ToolPosition["UpperLeft"] = "UL";
    ToolPosition["UpperRight"] = "UR";
    ToolPosition["UpperMidLeft"] = "UML";
    ToolPosition["UpperMidRight"] = "UMR";
    ToolPosition["LowerMidLeft"] = "LML";
    ToolPosition["LowerMidRight"] = "LMR";
    ToolPosition["LowerLeft"] = "LL";
    ToolPosition["LowerRight"] = "LR";
})(ToolPosition || (ToolPosition = {}));
var DeviceKind;
(function (DeviceKind) {
    DeviceKind["Mobile"] = "mobile";
    DeviceKind["Desktop"] = "desktop";
})(DeviceKind || (DeviceKind = {}));

var TimingFrequency;
(function (TimingFrequency) {
    TimingFrequency["EveryPage"] = "on_every_page";
    TimingFrequency["OncePerVisit"] = "once_per_visit";
    TimingFrequency["OncePerVisitor"] = "once_per_visitor";
    TimingFrequency["OncePerProperty"] = "once_per_property";
    TimingFrequency["OncePerBrand"] = "once_per_brand";
})(TimingFrequency || (TimingFrequency = {}));

var TriggerKind;
(function (TriggerKind) {
    TriggerKind["Load"] = "load";
    TriggerKind["Scroll"] = "scroll";
    TriggerKind["Idle"] = "idle";
})(TriggerKind || (TriggerKind = {}));

var ToolSize;
(function (ToolSize) {
    ToolSize["Regular"] = "regular";
    ToolSize["Compact"] = "compact";
})(ToolSize || (ToolSize = {}));
var LocaleImageKind;
(function (LocaleImageKind) {
    LocaleImageKind["Single"] = "single";
    LocaleImageKind["Multi"] = "multi";
})(LocaleImageKind || (LocaleImageKind = {}));
var ToolLayoutKind;
(function (ToolLayoutKind) {
    ToolLayoutKind["Bar"] = "bar";
    ToolLayoutKind["Circular"] = "circular";
    ToolLayoutKind["CustomImage"] = "custom-image";
    ToolLayoutKind["Fullscreen"] = "full-screen";
    ToolLayoutKind["FullscreenMini"] = "full-screen-mini";
    ToolLayoutKind["LowerNotification"] = "lower-notification";
    ToolLayoutKind["NotificationTab"] = "notification-tab";
    ToolLayoutKind["Sidebar"] = "sidebar";
    ToolLayoutKind["SideGradient"] = "side-gradient";
    ToolLayoutKind["SlideIn"] = "slide-in";
    ToolLayoutKind["Square"] = "square";
    ToolLayoutKind["SquareImage"] = "square-image";
    ToolLayoutKind["Sticky"] = "sticky";
    ToolLayoutKind["StickyImage"] = "sticky-image";
})(ToolLayoutKind || (ToolLayoutKind = {}));
var ToolContentAlignment;
(function (ToolContentAlignment) {
    ToolContentAlignment["Left"] = "left";
    ToolContentAlignment["Center"] = "center";
    ToolContentAlignment["Right"] = "right";
})(ToolContentAlignment || (ToolContentAlignment = {}));
var ToolEntryBehaviour;
(function (ToolEntryBehaviour) {
    ToolEntryBehaviour["Inline"] = "inline";
    ToolEntryBehaviour["Overlay"] = "overlay";
})(ToolEntryBehaviour || (ToolEntryBehaviour = {}));

({
    [ActivityKind.NowViewing]: 'There are XXXXXX people looking at this hotel right now',
    [ActivityKind.TodayViewed]: 'XXXXXX people have looked at this hotel today',
    [ActivityKind.BookedToday]: 'XXXXXX people have already booked today',
    [ActivityKind.LastReservation]: 'Last reservation was XXXXXX hours ago',
    [ActivityKind.DiscountToday]: 'XXXXXX% discount only today',
    [ActivityKind.TodaySpecialOffer]: 'Today\'s special offer: XXXXXX',
});
({
    [PerkTooltipKind.None]: 'none',
    [PerkTooltipKind.SubjectToAvailibity]: 'Subject to availability',
    [PerkTooltipKind.WebExclusive]: 'Web exclusive',
    [PerkTooltipKind.OnlyForRegisterdUsers]: 'Only for registered users',
    [PerkTooltipKind.OnlyForSpecificRates]: 'Only for specific rates',
});

const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "I18nT",
  props: {
    keypath: {},
    tag: { default: "span" }
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const attrs = useAttrs();
    const { t } = useI18n();
    const sortedSlotsInString = Object.keys(slots).sort(
      (a, b) => t(props.keypath).indexOf(`{${a}}`) - t(props.keypath).indexOf(`{${b}}`)
    );
    const childrenNodes = sortedSlotsInString.reduce(
      (acc, key, idx) => {
        const masterString = t(props.keypath);
        const prevTarget = `{${sortedSlotsInString[idx - 1]}}`;
        const target = `{${key}}`;
        const startPosition = masterString.indexOf(prevTarget) !== -1 ? masterString.indexOf(prevTarget) + prevTarget.length : 0;
        const targetPosition = masterString.indexOf(target);
        acc.push(
          masterString.slice(startPosition, targetPosition),
          slots[key]()
        );
        if (idx === sortedSlotsInString.length - 1) {
          acc.push(
            masterString.slice(targetPosition + target.length)
          );
        }
        return acc;
      },
      []
    );
    const root = () => h(
      props.tag,
      attrs,
      childrenNodes
    );
    return (_ctx, _cache) => {
      return openBlock(), createBlock(root);
    };
  }
});

function useTextDirection(isRightAlign) {
  return isRightAlign ? "rtl" : "ltr";
}

function useAutoClose({
  enabled,
  delay,
  callback
}) {
  const interval = setTimeout(() => {
    if (enabled && delay > 0) {
      callback();
    }
  }, delay * 1e3);
  const clear = () => clearTimeout(interval);
  onBeforeUnmount(clear);
  return {
    clear
  };
}

function useDeviceFeatures() {
  const isHoverCapable = window.matchMedia("(any-hover: hover)").matches;
  return {
    isHoverCapable
  };
}

function useInlinerWidth({ width, widthUnit }) {
  if (!width || width === "auto") {
    return "100%";
  }
  const unit = widthUnit || "px";
  return `${width}${unit}`;
}

const startThreshold = 10;
const endThreshold = 100;
function useSwipeDown(element, options) {
  const distanceY = ref(0);
  const { lengthY, direction } = useSwipe(
    element,
    {
      threshold: startThreshold,
      onSwipe() {
        if (direction.value === "down") {
          distanceY.value = lengthY.value;
        }
      },
      onSwipeEnd() {
        if (direction.value === "down" && Math.abs(lengthY.value) > endThreshold) {
          options.onEnd();
          return;
        }
        distanceY.value = 0;
      }
    }
  );
  return { distanceY };
}

const icon = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21" fill="currentColor">
  <path fill-rule="evenodd" d="M4.166 5a8.25 8.25 0 1111.668 11.667A8.25 8.25 0 014.166 4.999zM10 4.082a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zm-.75 4.25a.75.75 0 01.75-.75h.008a.75.75 0 010 1.5H10a.75.75 0 01-.75-.75zm-.833 2.5a.75.75 0 01.75-.75H10a.75.75 0 01.75.75v2.583h.083a.75.75 0 010 1.5H10a.75.75 0 01-.75-.75v-2.583h-.083a.75.75 0 01-.75-.75z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const _hoisted_1$4 = { class: "main-rating__score lightext" };
const _hoisted_2$3 = { class: "main-rating__average darktext" };
const _hoisted_3$3 = { class: "flex items-center space-x-1 darktext leading-4" };
const _hoisted_4$3 = { class: "main-rating__note" };
const _hoisted_5$2 = { class: "py-2 px-3" };
const _hoisted_6$1 = { class: "lightext" };
const _hoisted_7$1 = { class: "main-rating__based main-rating__based--large" };
const _hoisted_8 = { class: "main-rating__based main-rating__based--short" };
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "MainRating",
  props: {
    data: {},
    colors: {},
    orientation: { default: "horizontal" },
    compactSize: { type: [String, Boolean], default: false },
    textStyle: { default: () => ({
      score: {
        size: "16px",
        weight: "600"
      },
      average: {
        size: "32px",
        weight: "600"
      },
      note: {
        size: "14px",
        weight: "600"
      },
      based: {
        size: "12px",
        weight: "400"
      }
    }) },
    showInfoBtn: { type: Boolean },
    tooltip: { default: () => ({
      placement: "top",
      zIndex: 99999,
      container: "body"
    }) },
    tooltipPlacement: {},
    tooltipZIndex: {}
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "02c39d04": props.colors.darkText,
      "6d0cb708": props.colors.lightText,
      "53ff22aa": props.textStyle.score.size,
      "57547ee1": props.textStyle.score.weight,
      "54f682bf": props.textStyle.average.size,
      "1017a494": props.textStyle.average.weight,
      "ce7d73e0": props.textStyle.note.size,
      "741b60c7": props.textStyle.note.weight,
      "3e96cbae": props.textStyle.based.size,
      "e6ebdac0": props.textStyle.based.weight
    }));
    const props = __props;
    const { t } = useI18n();
    const { isHoverCapable } = useDeviceFeatures();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          "main-rating",
          `main-rating--${props.compactSize ? "horizontal" : props.orientation}`,
          props.compactSize ? `main-rating--compact-${props.compactSize}` : void 0
        ]),
        "data-testid": "main-rating"
      }, [
        createElementVNode("p", _hoisted_1$4, [
          createElementVNode("span", _hoisted_2$3, toDisplayString(props.data.averageFormatted), 1),
          _cache[0] || (_cache[0] = createElementVNode("span", null, " / ", -1)),
          createElementVNode("span", null, toDisplayString(props.data.maxScore), 1)
        ]),
        createElementVNode("div", {
          class: normalizeClass({ "flex flex-col items-center": props.orientation === "vertical" })
        }, [
          createElementVNode("div", _hoisted_3$3, [
            createElementVNode("p", _hoisted_4$3, toDisplayString(props.data.noteFormatted), 1),
            props.showInfoBtn ? (openBlock(), createBlock(unref(Tooltip), {
              key: 0,
              mode: unref(isHoverCapable) ? "hover" : "click",
              placement: props.tooltip.placement,
              "z-index-tooltip": props.tooltip.zIndex,
              container: props.tooltip.container
            }, {
              trigger: withCtx(() => [
                createVNode(unref(icon), {
                  "aria-label": unref(t)("Information icon"),
                  class: "w-4 h-4"
                }, null, 8, ["aria-label"])
              ]),
              tooltip: withCtx(() => [
                createElementVNode("div", _hoisted_5$2, [
                  renderSlot(_ctx.$slots, "providersInfo", {}, void 0, true)
                ])
              ]),
              _: 3
            }, 8, ["mode", "placement", "z-index-tooltip", "container"])) : createCommentVNode("", true)
          ]),
          createElementVNode("div", _hoisted_6$1, [
            createElementVNode("p", _hoisted_7$1, toDisplayString(unref(t)("based on {number} reviews", { number: props.data.totalReviews })), 1),
            createElementVNode("p", _hoisted_8, toDisplayString(unref(t)("{num} reviews", { num: props.data.totalReviews })), 1)
          ])
        ], 2)
      ], 2);
    };
  }
});

const MainRating = /* @__PURE__ */ _export_sfc$1(_sfc_main$4, [["__scopeId", "data-v-cb8169b6"]]);

const _hoisted_1$3 = {
  class: "review",
  "data-testid": "review-item"
};
const _hoisted_2$2 = {
  key: 0,
  class: "review__header"
};
const _hoisted_3$2 = { class: "review__body" };
const _hoisted_4$2 = { class: "bold" };
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "Review",
  props: {
    review: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$3, [
        _ctx.review.title ? (openBlock(), createElementBlock("div", _hoisted_2$2, ' "' + toDisplayString(_ctx.review.title) + '" ', 1)) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_3$2, toDisplayString(_ctx.review.text), 1),
        createVNode(unref(_sfc_main$5), {
          keypath: "Posted on {reviewer}",
          tag: "div",
          class: "review__footer"
        }, {
          reviewer: withCtx(() => [
            createElementVNode("span", _hoisted_4$2, toDisplayString(_ctx.review.reviewer), 1)
          ]),
          _: 1
        })
      ]);
    };
  }
});

const Review = /* @__PURE__ */ _export_sfc$1(_sfc_main$3, [["__scopeId", "data-v-4d472757"]]);

const _hoisted_1$2 = { class: "reviewList" };
const _hoisted_2$1 = { class: "reviewList__header" };
const _hoisted_3$1 = { class: "reviewList__filters" };
const _hoisted_4$1 = { key: 1 };
const _hoisted_5$1 = { class: "reviewList__header mt-2" };
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "ReviewList",
  props: {
    reviews: {},
    reviewLanguages: {}
  },
  setup(__props) {
    const props = __props;
    const { t } = useI18n();
    const selectedType = ref("all");
    const selectedLanguage = ref("all");
    const reviewsEl = ref();
    const typeOptions = computed(() => {
      const uniqueTypes = [...new Set(props.reviews.map((review) => review.type))];
      const options = uniqueTypes.map((type) => ({
        label: t(type),
        value: type.toLowerCase()
      }));
      options.unshift({
        label: t("All traveler types"),
        value: "all"
      });
      return options;
    });
    const langOptions = computed(() => {
      const options = props.reviewLanguages.map((item) => ({
        label: item.language,
        value: item.langCode
      }));
      options.unshift({
        label: t("All languages"),
        value: "all"
      });
      return options;
    });
    const resetListScroll = () => {
      if (reviewsEl.value?.scrollTo) {
        reviewsEl.value.scrollTo(0, 0);
      }
    };
    const filteredReviews = computed(() => props.reviews.filter((review) => {
      if (selectedType.value === "all" && selectedLanguage.value === "all") {
        return true;
      }
      if (selectedType.value === "all") {
        return review.language.toLowerCase() === selectedLanguage.value;
      }
      if (selectedLanguage.value === "all") {
        return review.type.toLowerCase() === selectedType.value;
      }
      return review.type.toLowerCase() === selectedType.value && review.language.toLowerCase() === selectedLanguage.value;
    }));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$2, [
        createElementVNode("h2", _hoisted_2$1, toDisplayString(unref(t)("Highlighted reviews")), 1),
        createElementVNode("div", _hoisted_3$1, [
          createVNode(unref(CustomSelect), {
            modelValue: selectedType.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event) => selectedType.value = $event),
              resetListScroll
            ],
            options: typeOptions.value,
            class: "reviewList__filters--type",
            "data-testid": "review-type"
          }, null, 8, ["modelValue", "options"]),
          createVNode(unref(CustomSelect), {
            modelValue: selectedLanguage.value,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event) => selectedLanguage.value = $event),
              resetListScroll
            ],
            options: langOptions.value,
            class: "reviewList__filters--language",
            "data-testid": "review-language"
          }, null, 8, ["modelValue", "options"])
        ]),
        createElementVNode("div", {
          ref_key: "reviewsEl",
          ref: reviewsEl,
          class: "reviewList__reviews",
          tabindex: "0"
        }, [
          filteredReviews.value.length > 0 ? (openBlock(), createBlock(unref(List), {
            key: 0,
            items: filteredReviews.value,
            "data-testid": "review-list"
          }, {
            default: withCtx(({ item }) => [
              createVNode(Review, { review: item }, null, 8, ["review"])
            ]),
            _: 1
          }, 8, ["items"])) : (openBlock(), createElementBlock("div", _hoisted_4$1, [
            createElementVNode("p", _hoisted_5$1, toDisplayString(unref(t)("No reviews found")), 1)
          ]))
        ], 512)
      ]);
    };
  }
});

const ReviewList = /* @__PURE__ */ _export_sfc$1(_sfc_main$2, [["__scopeId", "data-v-7175abcb"]]);

const _hoisted_1$1 = ["innerHTML"];
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "PropertyRanking",
  props: {
    config: {},
    hightlightColor: {},
    fontSize: { default: "small" }
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "fa8b81fe": hightlightColor.value
    }));
    const props = __props;
    const { t } = useI18n();
    const theme = useTheme();
    const propertyLocation = computed(() => props.config.orLocName || props.config.hotelGeoname || props.config.hotelLocation);
    const showPositionPercent = computed(() => !props.config.topPercentType || props.config.topPercentType !== 2);
    const hotelTypeString = computed(() => {
      switch (props.config.hotelType) {
        case 2:
          return t("Resorts");
        case 3:
          return t("B&Bs");
        case 4:
          return t("Apartments");
        case 5:
          return t("Campsites");
        case 6:
          return t("Aparthotels");
        case 7:
          return t("Hostels");
        case 8:
          return t("Restaurants");
        default:
          return t("Hotels");
      }
    });
    const hightlightColor = computed(() => props.hightlightColor ?? theme.actionColor.base);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("p", {
        class: normalizeClass([
          "propertyRating text-center leading-4",
          props.fontSize === "large" ? "text-lg" : "text-sm"
        ]),
        innerHTML: unref(t)(
          "<em>TOP {position}</em> {hotelType} in {location}",
          {
            position: `${props.config.topPercent}${showPositionPercent.value ? "%" : ""}`,
            hotelType: hotelTypeString.value,
            location: propertyLocation.value || ""
          }
        )
      }, null, 10, _hoisted_1$1);
    };
  }
});

const PropertyRanking = /* @__PURE__ */ _export_sfc$1(_sfc_main$1, [["__scopeId", "data-v-5f02573f"]]);

const _hoisted_1 = { class: "providersInfo font-base" };
const _hoisted_2 = { class: "mb-2 font-semibold" };
const _hoisted_3 = { class: "flex gap-1 items-baseline" };
const _hoisted_4 = { class: "font-semibold" };
const _hoisted_5 = {
  key: 0,
  class: "text-grey-500 text-xs"
};
const _hoisted_6 = { class: "text-base item__score" };
const _hoisted_7 = { class: "text-grey-500" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProvidersInfo",
  props: {
    data: {},
    direction: { default: "ltr" },
    textStyle: { default: () => ({
      score: {
        weight: "700"
      }
    }) }
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "625c066a": props.direction,
      "9996451a": props.textStyle.score.weight
    }));
    const props = __props;
    const { t } = useI18n();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("p", _hoisted_2, toDisplayString(unref(t)("Reviews by Source")), 1),
        createVNode(unref(RecordGrid), {
          items: props.data,
          direction: "column",
          responsive: false,
          class: "leading-5"
        }, {
          name: withCtx(({ item }) => [
            createElementVNode("div", _hoisted_3, [
              createElementVNode("span", _hoisted_4, toDisplayString(item.name), 1),
              item.totalReviews ? (openBlock(), createElementBlock("span", _hoisted_5, toDisplayString(unref(t)("{num} reviews", { num: item.totalReviews })), 1)) : createCommentVNode("", true)
            ])
          ]),
          value: withCtx(({ item }) => [
            createElementVNode("span", _hoisted_6, toDisplayString(item.value.score), 1),
            createElementVNode("span", _hoisted_7, "/" + toDisplayString(item.value.max), 1)
          ]),
          _: 1
        }, 8, ["items"])
      ]);
    };
  }
});

const ProvidersInfo = /* @__PURE__ */ _export_sfc$1(_sfc_main, [["__scopeId", "data-v-7b33e715"]]);

const tailwindConfig = {
  content: [
    "./src/**/*.html",
    "./src/**/*.{vue,js,ts}"
  ],
  theme: {
    colors: {
      grey: {
        100: "#F1F1F1",
        500: "#9E9E9E",
        900: "#333333"
      },
      black: "#000",
      white: "#FFF"
    },
    fontSize: {
      xs: ".75rem",
      s: ".8125rem",
      sm: ".875rem",
      base: "1rem",
      lg: "1.125rem",
      xl: "1.25rem",
      "2xl": "1.5rem",
      "3xl": "2rem",
      "4xl": "2.5rem"
    },
    fontFamily: {
      base: "system-ui, Arial, Helvetica, sans-serif"
    }
  }
};

function useTailwindTheme() {
  return tailwindConfig.theme;
}

export { MainRating as M, PropertyRanking as P, RecordGrid as R, useAutoClose as a, ReviewList as b, ProvidersInfo as c, useTailwindTheme as d, useSwipeDown as e, useInlinerWidth as f, useTextDirection as u };
//# sourceMappingURL=useTailwindTheme.DuMV2zVC.js.map
